export enum StatusPurchaseOrder {
  CREATED = 'CREATED', // Menunggu konfirmasi RH
  WAITING_FOR_RH_CONFIRMATION = 'WAITING_FOR_RH_CONFIRMATION',
  WAITING_FOR_RD_CONFIRMATION = 'WAITING_FOR_RD_CONFIRMATION',
  WAITING_FOR_FINANCE_CONFIRMATION = 'WAITING_FOR_FINANCE_CONFIRMATION',
  NEED_CHANGE_ORDER_BY_DISTRIBUTOR = 'NEED_CHANGE_ORDER_BY_DISTRIBUTOR',
  NEED_CHANGE_ORDER_BY_RH = 'NEED_CHANGE_ORDER_BY_RH',
  NEED_APPROVE_REGIONAL_DIRECTOR = 'NEED_APPROVE_REGIONAL_DIRECTOR', // Menunggu Konfirmasi RD
  NEED_APPROVE_REGIONAL_FINANCE = 'NEED_APPROVE_REGIONAL_FINANCE', // Menunggu Konfirmasi Finance
  NEED_CHANGE_DISCOUNT = 'NEED_CHANGE_DISCOUNT', // Menunggu Konfirmasi RH
  RESERVED = 'RESERVED', // Siap
  OUTSTANDING = 'OUTSTANDING', // Diproses Sebagian
  ON_PROGRESS = 'ON_PROGRESS', // Diproses
  COMPLETED = 'COMPLETED', // Selesai
  PARTIAL_COMPLETED = 'PARTIAL_COMPLETED', // Selesai Sebagian
  EXPIRED = 'EXPIRED', // Kedaluwarsa
  CANCEL_BY_DISTRIBUTOR = 'CANCEL_BY_DISTRIBUTOR', // Dibatalkan Distributor
  CANCEL_BY_RH = 'CANCEL_BY_DISTRIBUTOR', // Dibatalkan RH
  CANCEL_BY_MARKETING = 'CANCEL_BY_MARKETING', // Dibatalkan Marketing
}

export enum EnumStatusPurchaseOrderString {
  WAITING_FOR_RH_CONFIRMATION = "Menunggu Konfirmasi RH",
  WAITING_FOR_RD_CONFIRMATION = "Menunggu Konfirmasi RD",
  WAITING_FOR_FINANCE_CONFIRMATION = "Menunggu Konfirmasi Finance",
  NEED_CHANGE_ORDER_BY_DISTRIBUTOR = "Butuh Perbaikan Distributor",
  NEED_CHANGE_ORDER_BY_RH = "Butuh Perbaikan RH",
  RESERVED = "Siap Diproses",
  OUTSTANDING = "Diproses Sebagian",
  ON_PROGRESS = "Diproses",
  COMPLETED = "Selesai",
  PARTIAL_COMPLETED = "Selesai Sebagian",
  EXPIRED = "Kadaluwarsa",
  CANCEL = "Dibatalkan"
}

export enum StatusSalesOrder {
  REQUEST = 'REQUEST',
  OUTSTANDING = 'OUTSTANDING',
  CREATED = 'CREATED', // Waiting Sales
  WAITING_ERP = 'WAITING_ERP', // Sales Approve
  CONFIRMED = 'CONFIRMED', // Need Fulfill
  EXPIRED = 'EXPIRED', // In Progress
  REJECTED = 'REJECTED', // Expired
  ON_PROGRESS_SCAN = 'ON_PROGRESS_SCAN',
  ON_PROGRESS = 'ON_PROGRESS', // Completed
  ON_DELIVERY = 'ON_DELIVERY', // delivery
  PARTIAL_COMPLETED = 'PARTIAL_COMPLETED', // delivery
  COMPLETED = 'COMPLETED',
  READY_TO_PROGRESS = 'READY_TO_PROGRESS',
  NEED_PROGRESS = 'NEED_PROGRESS',
}

export enum StatusSalesOrderLabel {
  REQUEST = 'Menunggu Konfirmasi Pusat',
  OUTSTANDING = 'Harus Dipenuhi',
  CREATED = 'Pending', // Waiting Sales
  // WAITING_ERP = 'WAITING_ERP', // Sales Approve
  CONFIRMED = 'Diproses', // Need Fulfill
  EXPIRED = 'Expired', // In Progress
  REJECTED = 'Ditolak', // Expired
  // ON_PROGRESS_SCAN = 'ON_PROGRESS_SCAN',
  ON_PROGRESS = 'Siap Dikirim', // Completed
  ON_DELIVERY = 'Sedang Dikirim', // delivery
  PARTIAL_COMPLETED = 'Selesai Sebagian', // delivery
  COMPLETED = 'Selesai',
}
